<h2 mat-dialog-title>Pick a Location</h2>

<div class="flex justify-center align-items-center" style="margin:20px 10px 10px 20px ;">
    
    <mat-form-field appearance="outline" class="half-width">
      <input matInput    [(ngModel)]="searchQuery" placeholder="Type to search ..."
      (ngModelChange)="onSearchChange($event)"
   />

       </mat-form-field>
   

  </div>
  

<div #mapContainer style="height: 400px; border: 1px solid #ccc;"></div>

<div *ngIf="pickedCoordinates" style="margin-top: 10px;">
  <strong>Selected:</strong>
  Lat: {{ pickedCoordinates.lat }}, Lng: {{ pickedCoordinates.lng }}
</div>

    <div class="form-actions" style="margin: 1.5em; text-align: right;">
        <button
          mat-raised-button
          color="warn"
          style="margin-right: 5px"
          color="warn"
          type="button"
          
        (click)="close()">Cancel</button>
        <button
        matButton
          mat-raised-button
          color="primary"
          type="button"
          (click)="selectLocation()">Select</button>
    
</div>
